<a *ngIf="banner" [href]="banner.ctaUrl?.url">
	<div class="obg-m-common-banner-image">
		<img loading="lazy" [title]="banner.image?.altText" [src]="banner.image?.url || fallbackImageUrl" />
	</div>

	<div class="obg-m-common-banner-data">
		<h2 class="obg-m-common-banner-header">{{ banner.title }}</h2>

		<div>
			<p class="obg-m-common-banner-description" *ngIf="banner.description">
				{{ banner.description | truncate: 67 : "&hellip;" }}
			</p>

			<button mat-flat-button color="primary">{{ banner?.ctaLabel }}</button>
		</div>
	</div>
</a>

<div class="obg-m-common-banner-terms" *ngIf="banner && banner.termsAndConditions">
	<div class="obg-m-common-banner-terms-title">{{ "customer-support.terms-and-conditions" | translate }}</div>
	<span [innerHtml]="banner.termsAndConditions"></span>
</div>
